import src from "IMAGE";
export default { src, width: 154, height: 49, blurWidth: 0, blurHeight: 0};
